import { h, Component } from 'preact';
import style from './style';

var classNames = require('classnames/bind');
var cx = classNames.bind(style);

export default class Loading extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div class={cx("loading")}>
                <p class={cx("emoji")}>🔍</p>
                <p>Loading</p>
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./components/loading/index.js